import React from "react";
import { pageTitle } from "../../helpers/PageTitle";

export default function TermsOfUse() {
  pageTitle("Terms of Use");
  return (
    
    <div style={{ margin: "80px auto", padding: 24, paddingTop: "80px" }}>
            <style>
        {`
          h1 {
            text-align: center;
          }
          h2 {
            margin-top: 30px;
            margin-bottom: 15px;
            font-size: 25px;
          }
          ul {
            margin-left: 20px;
          }
          .privacy-content {
            margin-top: 80px;
            padding-left: 50px;
            margin: 80px auto;
          }
          .effective-date {
            font-weight: bold;
            font-size: 18px;
          }
          .email-link {
            color: white;
            text-decoration: none;
          }
             .padding {
      padding-left: 50px;
    }
            @media screen and (max-width: 991px) {
    body, html {
        font-size: 16px;
        line-height: 1.6em;
    }
         h2 {
           font-size: 18px;
          }
           h1 {
    font-size: 29px;
}
    .privacy-content {
    margin-top: 80px;
    padding-left: 0px;
    }
    .padding {
      padding-left: 0px;
    }

        `}
      </style>
      <h1 style={{ textAlign: "center" }}>Terms & Conditions</h1>
      <div style={{ marginTop: "80px",  maxWidth: "", margin: "80px auto" }} className="padding">
        <p style={{ fontWeight: "bold", fontSize: "18px" }}>Effective Date: Sunday, 22 June 2025</p>
        
        <p>
          Welcome to the website of Ignite Sports Pavilion. By accessing or using our website and facilities, you agree to the following Terms & Conditions:
        </p>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>1. Use of Services</h2>
        <ul style={{ marginLeft: "20px" }}>
          <li>Bookings must be made via our website or official contact number.</li>
          <li>Users must follow all safety guidelines and instructions provided by staff.</li>
        </ul>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>2. Payments & Cancellations</h2>
        <ul style={{ marginLeft: "20px" }}>
          <li>All bookings must be paid in advance.</li>
          <li>Cancellations made within 24 hours of the booking time may not be eligible for a refund.</li>
        </ul>
        {/* <div style={{ color: '#00f3ff', fontWeight: 900, fontSize: '25px', marginBottom: 8, fontStyle: ' ', letterSpacing: 1 }}>Rain Policy for Court Bookings</div>
        <div id="rain-policy-content" style={{ padding: '32px 24px 24px 24px', background: 'rgba(10,20,30,0.98)', color: '#fff', fontSize: '1.08rem', lineHeight: 1.7 }}>
          <div style={{ marginBottom: 24 }}>
            <div style={{ color: '#00f3ff', fontWeight: 900, fontSize: '1.2rem', marginBottom: 8, fontStyle: ' ', letterSpacing: 1 }}>RAIN DELAY</div>
            <div>If rain interrupts play, the remaining time will be rescheduled to a later date based on court availability.</div>
          </div>
          <div style={{ marginBottom: 24 }}>
            <div style={{ color: '#00f3ff', fontWeight: 900, fontSize: '1.2rem', marginBottom: 8, fontStyle: ' ', letterSpacing: 1 }}>COURT CLOSURE</div>
            <div>If the arena is forced to close due to rain, all bookings during the affected time will be rescheduled to a future slot, subject to court availability.</div>
          </div>
          <div style={{ color: '#00f3ff', fontWeight: 900, fontSize: '1.2rem', marginBottom: 8, fontStyle: ' ', letterSpacing: 1 }}>ADDITIONAL TERMS</div>
          <ul style={{ marginLeft: 20, marginBottom: 0 }}>
            <li><span style={{ color: '#00f3ff', fontWeight: 700 }}>IGNITE SPORTS PAVILION</span> reserves the right to cancel or delay bookings due to rain.</li>
            <li>Players will be notified of cancellations or delays via the booking app and Instagram.</li>
            <li>Make-up sessions will be accommodated based on slot availability only.</li>
            <li>No refunds will be provided for rain-affected sessions.</li>
          </ul>
        </div> */}
    
        <RainPolicyDropdown />

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>3. Code of Conduct</h2>
        <ul style={{ marginLeft: "20px" }}>
          <li>Respectful behavior is expected at all times.</li>
          <li>Any damage to property or misconduct may result in removal from the premises or a permanent ban.</li>
        </ul>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>4. Liability</h2>
        <p>
          Ignite Sports Pavilion is not liable for injuries, loss, or damage arising from use of the facilities, except where caused by proven negligence.
        </p>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>5. Intellectual Property</h2>
        <p>
          All content on our website (logos, text, media) is the property of Ignite Sports Pavilion and may not be used without written permission.
        </p>

        <h2 style={{ marginTop: "30px", marginBottom: "15px" }}>6. Changes to Terms</h2>
        <p>
          We may modify these terms at any time. Continued use of the site and services constitutes acceptance of the updated terms.
        </p>

        <h2 style={{ marginTop: "40px", marginBottom: "15px" }}>Contact Information</h2>
        <div style={{ marginLeft: "20px" }}>
          <p><strong>Facebook:</strong>{" "}
            <a href="https://www.facebook.com/share/14DUqGxz1sd/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" style={{ color: "white", textDecoration: "none" }}>
              Ignite Sports Pavilion
            </a>
          </p>
          <p><strong>Instagram:</strong>{" "}
            <a href="https://www.instagram.com/ignitesportspavilion?igsh=MXRtOTFnd2IxdTVlcw==" target="_blank" rel="noopener noreferrer" style={{ color: "white", textDecoration: "none" }}>
              @ignitesportspavilion
            </a>
          </p>
          <p><strong>Address:</strong> St 13, Block 3, Near South City Hospital Clifton, Karachi</p>
          <p><strong>Contact Number:</strong> 0319 3IGNITE (3446483)</p>
          <p><strong>Email:</strong>{" "}
            <a href="mailto:info@ignitesportspavilion.com" style={{ color: "white", textDecoration: "none" }}>
              info@ignitesportspavilion.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

function RainPolicyDropdown() {
  const [open, setOpen] = React.useState(false);
  return (
    <div style={{
      margin: '40px 0',
      borderRadius: '12px',
      background: 'rgba(10,20,30,0.95)',
      boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
      color: '#fff',
      maxWidth: 600,
      padding: 0,
      border: '2px solid #00f3ff',
      overflow: 'hidden',
    }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          width: '100%',
          background: 'linear-gradient(90deg, #00f3ff 0%, #00bfff 100%)',
          color: '#222',
          fontWeight: 900,
          fontSize: '1.3rem',
          padding: '18px 24px',
          border: 'none',
          outline: 'none',
          cursor: 'pointer',
          letterSpacing: '1px',
          fontFamily: 'inherit',
          textShadow: '0 2px 8px #00f3ff44',
        }}
        aria-expanded={open}
        aria-controls="rain-policy-content"
      >
        RAIN POLICY FOR COURT BOOKINGS {open ? '▲' : '▼'}
      </button>
      {open && (
        <div id="rain-policy-content" style={{ padding: '32px 24px 24px 24px', background: 'rgba(10,20,30,0.98)', color: '#fff', fontSize: '1.08rem', lineHeight: 1.7 }}>
          <div style={{ marginBottom: 24 }}>
            <div style={{ color: '#00f3ff', fontWeight: 900, fontSize: '1.2rem', marginBottom: 8, fontStyle: ' ', letterSpacing: 1 }}>RAIN DELAY</div>
            <div>If rain interrupts play, the remaining time will be rescheduled to a later date based on court availability.</div>
          </div>
          <div style={{ marginBottom: 24 }}>
            <div style={{ color: '#00f3ff', fontWeight: 900, fontSize: '1.2rem', marginBottom: 8, fontStyle: ' ', letterSpacing: 1 }}>COURT CLOSURE</div>
            <div>If the arena is forced to close due to rain, all bookings during the affected time will be rescheduled to a future slot, subject to court availability.</div>
          </div>
          <div style={{ color: '#00f3ff', fontWeight: 900, fontSize: '1.2rem', marginBottom: 8, fontStyle: ' ', letterSpacing: 1 }}>ADDITIONAL TERMS</div>
          <ul style={{ marginLeft: 20, marginBottom: 0 }}>
            <li><span style={{ color: '#00f3ff', fontWeight: 700 }}>IGNITE SPORTS PAVILION</span> reserves the right to cancel or delay bookings due to rain.</li>
            <li>Players will be notified of cancellations or delays via the booking app and Instagram.</li>
            <li>Make-up sessions will be accommodated based on slot availability only.</li>
            <li>No refunds will be provided for rain-affected sessions.</li>
          </ul>
        </div>
      )}
    </div>
  );
} 